






import { Vue, Component } from 'vue-property-decorator';
import * as config from './config';
import { rules } from './api';
type Target = 'detail' | 'success';
@Component({
  components: {},
})
export default class Second extends Vue {
  option = config.OPTHINES;
  data: any = '';
  created() {
    rules(this.option.voteName).then((res: any) => {
      this.data = res.data;
    });
  }
}
